<template>
	<div id="survey-page" class="pageContent" >
		<div v-if="errorLoadingData">
			<p>Error.</p>
		</div>
      <div v-if="errorInfo !== null" >
         <p>{{errorInfo}}</p>
      </div>
      
		<div class="surveyContent" v-if="!isLoading && !errorLoadingData && errorInfo == null">
         <div class="testingInfo" v-if="this.testingMode==true && !isLoading && !errorLoadingData && errorInfo == null" >Testaustila. Vastauksia ei tallenneta!</div>
         <div class="introductory-paragraph" >
            <!-- technical hidden input -->
            <input type="hidden" v-model="fieldsUpdated" value="" >

            <div style="text-align:right;" v-if="languages.length > 1" >					
               <template v-for="l in languages" >
                  <span :key="'span'+l.value" v-if="l.first == false" >&nbsp;|&nbsp;</span>
                  <a onmouseover="this.style.cursor='pointer';" :key="l.value" v-on:click="setCurrentLanguage(l.value)" >{{l.text}}</a>
               </template>
            </div>

            <div><br></div>

            <div class="progressionBallsFLR" >
               <template v-if="currentPage !== 0" >
                  <template v-for="p in pages"  >
                     <template v-if="!(conditionalPages.includes(p.id)) || showConditionalPages.some(sp => sp.activates == p.id)" > 
                        <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-if="p.id == currentPage" >&#9679;</span><!--&#9899;-->
                        <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-else >&#9675;</span>
                     </template>
                  </template>
               </template>
            </div>
            <div v-if="(logo)" >
               <img v-if="(logo)" v-bind:src="logosUrl + logo" class="logo" >
            </div>            
            <!--
            <div class="row" >
               <div class="col-lg-9 col-md-9 col-sm-8 col-xs-12" >
                  <img v-if="(logo)" v-bind:src="logosUrl + logo" class="logo" >
               </div>
               <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 progressionBalls" >
                  <template v-if="currentPage !== 0" >
                     <template v-for="p in pages"  >
                        <template v-if="!(conditionalPages.includes(p.id)) || showConditionalPages.some(sp => sp.activates == p.id)" > 
                           <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-if="p.id == currentPage" >&#9679;</span>
                           <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-else >&#9675;</span>
                        </template>
                     </template>
                  </template>
               </div>
            </div>
            -->

            <!--
            <div class="logoAndProgression" >
               <div class="logo" >
                  <img v-if="(logo)" v-bind:src="logosUrl + logo" class="logo"  >					
               </div>
               <div class="progression">
                  <template v-if="currentPage !== 0" >
                     <template v-for="p in pages"  >
                        <template v-if="!(conditionalPages.includes(p.id)) || showConditionalPages.some(sp => sp.activates == p.id)" > 
                           <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-if="p.id == currentPage" >&#9679;</span>
                           <span :key="p.id" v-bind:style="'font-family:verdana;font-size:50px;color:'+pageIndicatorColor+';'" v-else >&#9675;</span>
                        </template>
                     </template>
                  </template>
               </div>
            </div>
            -->

            <div class="surveyTitle" >               
               <template v-if="currLang=='fi'">{{$store.state.survey.nimi.fi}}</template>
               <template v-if="currLang=='sv'">{{$store.state.survey.nimi.sv}}</template>
               <template v-if="currLang=='en'">{{$store.state.survey.nimi.en}}</template>               
            </div>
         
            <template v-if="currentPage == 0" >
               <!-- Final page -->
               <div class="pageTitle" v-if="currLang == 'fi' && finalPageNameFI !== '' && finalPageNameFI !== null && finalPageNameFI !== undefined" >{{finalPageNameFI}}</div>
					<div class="pageTitle" v-if="currLang == 'sv' && finalPageNameSWE !== '' && finalPageNameSWE !== null && finalPageNameSWE !== undefined" >{{finalPageNameSWE}}</div>
					<div class="pageTitle" v-if="currLang == 'en' && finalPageNameENG !== '' && finalPageNameENG !== null && finalPageNameENG !== undefined" >{{finalPageNameENG}}</div>
              
               <div v-if="currLang == 'fi'" class="leadParagraph" v-html="finalPageIngressiFI" ></div>
               <div v-if="currLang == 'sv'" class="leadParagraph" v-html="finalPageIngressiSWE" ></div>
               <div v-if="currLang == 'en'" class="leadParagraph" v-html="finalPageIngressiENG" ></div>

               <div v-if="finalPageSummary">
                  <div v-if="currLang == 'fi'" style="font-size: larger; font-weight: bold; margin-top: 1em;">Yhteenveto</div>
                  <div v-else-if="currLang == 'sv'" style="font-size: larger; font-weight: bold; margin-top: 1em;">Sammanfattning</div>
                  <div v-else-if="currLang == 'en'" style="font-size: larger; font-weight: bold; margin-top: 1em;">Summary</div>
                  <!-- Taas ois kiva jos näät ois modulaarisia nää kysymystyypit, nyt ruma copy-paste yhteenvetosivua varten. Toiminnallisuus estetty -->
                  <template v-for="page in pages">
                     <template v-if="!(conditionalPages.includes(page.id)) || showConditionalPages.some(sp => sp.activates == page.id)">
                        <div v-for="q in page.sivunKysymykset" :key="q.id">
                           <div class="single-question" v-show="!(conditionalQuestions.includes(q.id)) || showConditionalQuestions.some(sq => sq.activates == q.id)" >
                              <div class="questionText" >
                                 <template v-if="currLang=='fi'">{{q.kysymysTeksti}}</template>
                                 <template v-if="currLang=='sv'">{{q.kysymysTekstiRuotsiksi}}</template>
                                 <template v-if="currLang=='en'">{{q.kysymysTekstiEnglanniksi}}</template>
                                 <template v-if="q.pakollinen == true">&nbsp;*</template>
                              </div>
                              <template v-if="currLang=='fi' && q.lisateksti !== null && q.lisateksti !== '' && q.lisateksti !== undefined" >
                                 <p class="questionAdditionalText" v-html="q.lisateksti"></p>
                              </template>
                              <template v-if="currLang=='sv' && q.lisatekstiRuotsiksi !== null && q.lisatekstiRuotsiksi !== '' && q.lisatekstiRuotsiksi !== undefined" >
                                 <p class="questionAdditionalText" v-html="q.lisatekstiRuotsiksi"></p>
                              </template>    
                              <template v-if="currLang=='en' && q.lisatekstiEnglanniksi !== null && q.lisatekstiEnglanniksi !== '' && q.lisatekstiEnglanniksi !== undefined" >
                                 <p class="questionAdditionalText" v-html="q.lisatekstiEnglanniksi"></p>
                              </template>                                       
                              <p class="required" v-show="showRequiredInfoInQuestions.includes(q.id)" >{{getTranslation('UnansweredRequiredField',currLang)}}</p>

                              <!-- RADIOBUTTONS (summary)-->
                              <div v-if="q.kysymysTyyppi == 1" class="q-choices-radio" >
                                 <template v-for="c in q.kysymyksenVastausVaihtoehdot" >                     
                                    <label :key="c.id" class="label-radio" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                                       <input :ref="'qId'+q.id+'_cId'+c.id" type="radio" :id="q.id+'choice'+c.id" :name="'question'+q.id+'choices'" :value="c.id" 
                                                v-model="answers['qId'+q.id+'_choice']" disabled="true"
                                       >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                                    </label>
                                    <!--  -->
                                    <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_choice'] == c.id" disabled="true"></textarea>
                                 </template>                  
                              </div>
                              <!-- CHECKBOXES (summary)-->
                              <div v-if="q.kysymysTyyppi == 2" class="q-choices-checkboxes" >
                                 <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                                    <label :key="c.id" class="label-checkbox" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                                       <input :ref="'qId'+q.id+'_cId'+c.id" type="checkbox" :id="q.id+'choice'+c.id"  
                                                v-model="answers['qId'+q.id+'_cId'+c.id]" :value="c.id" disabled="true"
                                       >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                                    </label>
                                    <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_cId'+c.id] == true" disabled="true"></textarea>
                                 </template>
                              </div>
                              <!-- CHECKBOXES WITH MAX CHOICES (summary)-->
                              <div v-if="q.kysymysTyyppi == 10" class="q-choices-checkboxes" >
                                 <p v-if="currLang == 'fi'" style="font-size: smaller;">* Maksimissaan {{q.maxValintoja}} vastausta.</p>
                                 <p v-else-if="currLang == 'sv'" style="font-size: smaller;">* Max {{q.maxValintoja}} svar.</p>
                                 <p v-else-if="currLang == 'en'" style="font-size: smaller;">* Maximum {{q.maxValintoja}} answers.</p>
                                 <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                                    <label :key="c.id" class="label-checkbox" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                                       <input :ref="'qId'+q.id+'_cId'+c.id" type="checkbox" :id="q.id+'choice'+c.id"  
                                                v-model="answers['qId'+q.id+'_cId'+c.id]" :value="c.id" disabled="true"
                                       >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                                    </label>
                                    <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_cId'+c.id] == true" disabled="true" ></textarea>
                                 </template>
                              </div>
                           
                              <!-- DROPDOWN (summary)--> 
                              <div v-if="q.kysymysTyyppi == 5" class="q-choices-dropdown" >
                                 <select :ref="'qId'+q.id" class="form-control" v-model="answers['qId'+q.id+'_choice']" disabled="true" >
                                    <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                                       <template v-if="c.kysymysId == q.id && c.voimassa == true" >
                                          <option :key="c.id" :id="'choice'+c.id" :value="c.id" >{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}</option>
                                       </template>
                                    </template>								
                                 </select>
                              </div>
                              <!-- SCORABLES (summary)-->
                              <div v-if="q.kysymysTyyppi == 4" class="q-choices-score" >
                                 <!-- TABLE BOOTSTRAP STRIPED VERSIO -->
                                 <div class="table-responsive"> 
                                    <table class="table table-striped" >                     
                                       <thead>
                                          <tr>
                                          <td class="tdRadioBT" ><span class="scorableBold" >&nbsp;</span></td>
                                          <td class="tdRadioBT" v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" >
                                             <span v-if="q.kaanteinen" class="scorableBold" >{{parseInt(q.pisteetMax) - parseInt(n) + 1}}</span>
                                             <span v-else class="scorableBold" >{{ parseInt(n) + (parseInt(q.pisteetMin) - 1) }}</span>
                                          </td>
                                          <td v-if="!!q.eosTeksti && currLang=='fi'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTeksti}}</span></td>
                                          <td v-else-if="!!q.eosTekstiSwe && currLang=='sv'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTekstiSwe}}</span></td>
                                          <td v-else-if="!!q.eosTekstiEng && currLang=='en'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTekstiEng}}</span></td>
                                          <td v-else class="tdRadioBT" ><span class="scorableBold">&nbsp;-&nbsp;</span></td>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <template v-for="s in q.kysymyksenVastausVaihtoehdot" >										
                                             <template v-if="s.kysymysId == q.id && s.voimassa == true" >
                                                <tr :key="s.id" >	
                                                   <td>
                                                      <span class="scorableBold" >
                                                      <template v-if="currLang == 'fi'" >{{s.vaihtoehto}}</template>
                                                      <template v-else-if="currLang == 'sv'" >{{s.vaihtoehtoRuotsiksi}}</template>
                                                      <template v-else-if="currLang == 'en'" >{{s.vaihtoehtoEnglanniksi}}</template>
                                                      </span>
                                                   </td>
                                                   <td class="tdRadioBT" v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" >
                                                      <template v-if="!!q.kaanteinen">
                                                         <label :for="q.id+'scorable'+s.id+'score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" class="fillRadioLabelBT" >
                                                         <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" :value="parseInt(q.pisteetMax) - parseInt(n) + 1" disabled="true" >
                                                         </label>
                                                      </template>
                                                      <template v-else>                                          
                                                         <label :for="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" class="fillRadioLabelBT" >
                                                         <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" :value="parseInt(n) + (parseInt(q.pisteetMin) - 1)" disabled="true" >
                                                         </label>                                        
                                                      </template>
                                                   </td>                                          
                                                   <td class="tdRadioBT" >
                                                      <label :for="q.id+'scorable'+s.id+'score_nothing'" class="fillRadioLabelBT" >
                                                         <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_scoreEOS'" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score_nothing'" value="eos" disabled="true" >
                                                      </label>
                                                   </td>
                                                </tr>
                                             </template>							
                                          </template>	
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                              <!-- SINGLELINE TEXTFIELD (summary)-->	
                              <div v-if="q.kysymysTyyppi == 7" class="q-textfield" >
                                 <input type="text" v-model="answers['qId'+q.id]" class="form-control" disabled="true" >
                              </div>
                              <!-- MULTILINE TEXTFIELD (summary)-->	
                              <div v-if="q.kysymysTyyppi == 3" class="q-textarea" >
                                 <textarea v-model="answers['qId'+q.id]" class="form-control" disabled="true" ></textarea>                     
                              </div>
                              <!-- SMILEYS (summary)-->	
                              <div v-if="q.kysymysTyyppi == 8" class="q-smileys" >							
                                 <input type="hidden" v-model="answers['qId'+q.id+'_smiley']" ref="'qref'+q.id" value="" disabled="true" >
                                 <template v-if="q.naamaLkm == 2" >
                                    <div class="twoFace" >
                                       <b-row >
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                                          </b-col>
                                       </b-row>
                                    </div>
                                 </template>
                                 <template v-if="q.naamaLkm == 3" >
                                    <div class="threeFace" >
                                       <b-row>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 3) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/3b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                                          </b-col>
                                       </b-row>
                                    </div>
                                 </template>
                                 <template v-if="q.naamaLkm == 4" >
                                    <div class="fourFace" >
                                       <b-row>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 4) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/4b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 2) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/2b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                                          </b-col>
                                       </b-row>
                                    </div>
                                 </template>
                                 <template v-if="q.naamaLkm == 5" >
                                    <div class="fiveFace" >
                                       <b-row>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 4) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/4b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 3) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/3b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button v-bind:class="(answers['qId'+q.id+'_smiley'] == 2) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/2b.png" ></button>
                                          </b-col>
                                          <b-col class="faceCol" >
                                             <button disabled="true" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                                          </b-col>
                                       </b-row>
                                    </div>
                                 </template>
                              </div>
                              <!-- NPS (summary)-->
                              <div v-if="q.kysymysTyyppi == 9" class="q-nps" >		
                                 <ul class="NPS">
                                    <li v-for="n in 11" :key="n" >
                                       <input type="radio" :id="'qId'+q.id+'_nps'+(parseInt(n) - 1)" :name="'qId'+q.kysymysId+'_nps'" :value="(parseInt(n) - 1)" v-model="answers['qId'+q.id+'_nps']" disabled="true"/>
                                       <label :for="'qId'+q.id+'_nps'+(parseInt(n) - 1)">{{(parseInt(n) - 1)}}</label>
                                    </li>
                                 </ul>
                                 <div><br><br><br></div>
                              </div>               
                              <!-- COMMENTARY TEXTFIELD (summary)-->	
                              <template v-if="q.kommentti == true" >
                                 <div><br></div>	
                                 <div class="questionText" >
                                    <span class="question" >{{getTranslation('CommentsField',currLang)}}</span>                      
                                 </div>									
                                 <div class="q-textarea" >
                                    <textarea v-model="answers['qId'+q.id+'_comment']" class="form-control" disabled="true" ></textarea>
                                 </div>
                              </template>
                           </div>
                        </div>
                     </template>
                  </template>
               </div>
            </template>
            <template v-else >
               <!-- other than final page -->
               <div class="pageTitle" v-if="currLang == 'fi' && pages[currentPageIndex].nimi !== '' && pages[currentPageIndex].nimi !== null && pages[currentPageIndex].nimi !== undefined" >{{pages[currentPageIndex].nimi}}</div>
					<div class="pageTitle" v-if="currLang == 'sv' && pages[currentPageIndex].nimiRuotsiksi !== '' && pages[currentPageIndex].nimiRuotsiksi !== null && pages[currentPageIndex].nimiRuotsiksi !== undefined" >{{pages[currentPageIndex].nimiRuotsiksi}}</div>
					<div class="pageTitle" v-if="currLang == 'en' && pages[currentPageIndex].nimiEnglanniksi !== '' && pages[currentPageIndex].nimiEnglanniksi !== null  && pages[currentPageIndex].nimiEnglanniksi !== undefined" >{{pages[currentPageIndex].nimiEnglanniksi}}</div>
            
               <template v-if="postInfo !== null" >
                  <!-- FI Aloitussivun lähetyskohtainen teksti -->
                  <div class="leadParagraph" v-if="pages[currentPageIndex].id == firstPageId && currLang=='fi' && postInfo.aloitusSivunTeksti !== '' && postInfo.aloitusSivunTeksti !== null" >{{postInfo.aloitusSivunTeksti}}</div>
                  <!-- SWE Aloitussivun lähetyskohtainen teksti -->
                  <div class="leadParagraph" v-if="pages[currentPageIndex].id == firstPageId && currLang=='sv' && postInfo.aloitusSivunTekstiRuotsi !== '' && postInfo.aloitusSivunTekstiRuotsi !== null" >{{postInfo.aloitusSivunTekstiRuotsi}}</div>
                  <!-- ENG Aloitussivun lähetyskohtainen teksti -->
                  <div class="leadParagraph" v-if="pages[currentPageIndex].id == firstPageId && currLang=='en' && postInfo.aloitusSivunTekstiEnglanti !== '' && postInfo.aloitusSivunTekstiEnglanti !== null" >{{postInfo.aloitusSivunTekstiEnglanti}}</div>
               </template>

               <div class="leadParagraph" >
                  <template v-if="currLang=='fi'">{{pages[currentPageIndex].ingressi}}</template>
                  <template v-if="currLang=='sv'">{{pages[currentPageIndex].ingressiRuotsiksi}}</template>
                  <template v-if="currLang=='en'">{{pages[currentPageIndex].ingressiEnglanniksi}}</template>
               </div>
            
            </template>
         </div>
         
         <template v-if="(currentPage + '') !== 'f' && currentPage !== 0" >
            <div v-for="q in pages[currentPageIndex].sivunKysymykset" :key="q.id" >      
            
         
               <div class="single-question" v-show="!(conditionalQuestions.includes(q.id)) || showConditionalQuestions.some(sq => sq.activates == q.id)" >
                  <div class="questionText" >
                     <template v-if="currLang=='fi'">{{q.kysymysTeksti}}</template>
                     <template v-if="currLang=='sv'">{{q.kysymysTekstiRuotsiksi}}</template>
                     <template v-if="currLang=='en'">{{q.kysymysTekstiEnglanniksi}}</template>
                     <template v-if="q.pakollinen == true">&nbsp;*</template>
                  </div>
                  <template v-if="currLang=='fi' && q.lisateksti !== null && q.lisateksti !== '' && q.lisateksti !== undefined" >
                     <p class="questionAdditionalText" v-html="q.lisateksti"></p>
                  </template>
                  <template v-if="currLang=='sv' && q.lisatekstiRuotsiksi !== null && q.lisatekstiRuotsiksi !== '' && q.lisatekstiRuotsiksi !== undefined" >
                     <p class="questionAdditionalText" v-html="q.lisatekstiRuotsiksi"></p>
                  </template>    
                  <template v-if="currLang=='en' && q.lisatekstiEnglanniksi !== null && q.lisatekstiEnglanniksi !== '' && q.lisatekstiEnglanniksi !== undefined" >
                     <p class="questionAdditionalText" v-html="q.lisatekstiEnglanniksi"></p>
                  </template>                                       
                  <p class="required" v-show="showRequiredInfoInQuestions.includes(q.id)" >{{getTranslation('UnansweredRequiredField',currLang)}}</p>

                  <!-- RADIOBUTTONS -->
                  <div v-if="q.kysymysTyyppi == 1" class="q-choices-radio" >
                     <template v-for="c in q.kysymyksenVastausVaihtoehdot" >                     
                        <label :key="c.id" class="label-radio" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                           <input :ref="'qId'+q.id+'_cId'+c.id" type="radio" :id="q.id+'choice'+c.id" :name="'question'+q.id+'choices'" :value="c.id" 
                                    v-model="answers['qId'+q.id+'_choice']" 
                                    @change="singleChoiceQuestionConditionals($event, q.id, pages[currentPageIndex].id, (questionsThatActivates.includes(q.id)))" 
                           >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                        </label>
                        <!--  -->
                        <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_choice'] == c.id" ></textarea>
                     </template>                  
                  </div>
                  <!-- CHECKBOXES -->
                  <div v-if="q.kysymysTyyppi == 2" class="q-choices-checkboxes" >
                     <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                        <label :key="c.id" class="label-checkbox" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                           <input :ref="'qId'+q.id+'_cId'+c.id" type="checkbox" :id="q.id+'choice'+c.id"  
                                    v-model="answers['qId'+q.id+'_cId'+c.id]" :value="c.id" 
                                    @change="checkboxConditionals($event, q.id, pages[currentPageIndex].id, (choicesThatActivates.includes(c.id)))" 
                           >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                        </label>
                        <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_cId'+c.id] == true" ></textarea>
                     </template>
                  </div>
                  <!-- CHECKBOXES WITH MAX CHOICES -->
                  <div v-if="q.kysymysTyyppi == 10" class="q-choices-checkboxes" >
                     <p v-if="currLang == 'fi'" style="font-size: smaller;">* Maksimissaan {{q.maxValintoja}} vastausta.</p>
                     <p v-else-if="currLang == 'sv'" style="font-size: smaller;">* Max {{q.maxValintoja}} svar.</p>
                     <p v-else-if="currLang == 'en'" style="font-size: smaller;">* Maximum {{q.maxValintoja}} answers.</p>
                     <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                        <label :key="c.id" class="label-checkbox" :for="q.id+'choice'+c.id" v-if="c.kysymysId == q.id && c.voimassa == true" >
                           <input :ref="'qId'+q.id+'_cId'+c.id" type="checkbox" :id="q.id+'choice'+c.id"  
                                    v-model="answers['qId'+q.id+'_cId'+c.id]" :value="c.id"
                                    @change="checkMaxChoices(q.id, q.id+'choice'+c.id, 'qId'+q.id+'_cId'+c.id, q.maxValintoja, q.kysymyksenVastausVaihtoehdot) ? checkboxConditionals($event, q.id, pages[currentPageIndex].id, (choicesThatActivates.includes(c.id))) : null"                                     
                           >&nbsp;{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}
                        </label>
                        <textarea class="form-control" :key="'oc'+c.id" v-if="c.muuVaihtoehto==true" v-model="answers['qId'+q.id+'_cId'+c.id+'_otherChoiceText']" v-show="answers['qId'+q.id+'_cId'+c.id] == true" ></textarea>
                     </template>
                  </div>
               
                  <!-- DROPDOWN --> 
                  <div v-if="q.kysymysTyyppi == 5" class="q-choices-dropdown" >
                     <select :ref="'qId'+q.id" class="form-control" v-model="answers['qId'+q.id+'_choice']" @change="singleChoiceQuestionConditionals($event, q.id, pages[currentPageIndex].id, (questionsThatActivates.includes(q.id)))" >
                        <template v-for="c in q.kysymyksenVastausVaihtoehdot" >
                           <template v-if="c.kysymysId == q.id && c.voimassa == true" >
                              <option :key="c.id" :id="'choice'+c.id" :value="c.id" >{{formatChoice(c.numeerinenArvo, currLang, c.vaihtoehto, c.vaihtoehtoRuotsiksi, c.vaihtoehtoEnglanniksi)}}</option>
                           </template>
                        </template>								
                     </select>
                  </div>
                  <!-- SCORABLES -->
                  <div v-if="q.kysymysTyyppi == 4" class="q-choices-score" >
                     <!-- TABLE BOOTSTRAP STRIPED VERSIO -->
                     <div class="table-responsive"> 
                        <table class="table table-striped" >                     
                           <thead>
                              <tr>
                              <td class="tdRadioBT" ><span class="scorableBold" >&nbsp;</span></td>
                              <td class="tdRadioBT" v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" >
                                 <span v-if="q.kaanteinen" class="scorableBold" >{{parseInt(q.pisteetMax) - parseInt(n) + 1}}</span>
                                 <span v-else class="scorableBold" >{{ parseInt(n) + (parseInt(q.pisteetMin) - 1) }}</span>
                              </td>
                              <td v-if="!!q.eosTeksti && currLang=='fi'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTeksti}}</span></td>
                              <td v-else-if="!!q.eosTekstiSwe && currLang=='sv'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTekstiSwe}}</span></td>
                              <td v-else-if="!!q.eosTekstiEng && currLang=='en'" class="tdRadioBT" style="padding:0px; width: 100px;"><span class="scorableBold">{{q.eosTekstiEng}}</span></td>
                              <td v-else class="tdRadioBT" ><span class="scorableBold">&nbsp;-&nbsp;</span></td>
                              </tr>
                           </thead>
                           <tbody>
                              <template v-for="s in q.kysymyksenVastausVaihtoehdot" >										
                                 <template v-if="s.kysymysId == q.id && s.voimassa == true" >
                                    <tr :key="s.id" >	
                                       <td>
                                          <span class="scorableBold" >
                                          <template v-if="currLang == 'fi'" >{{s.vaihtoehto}}</template>
                                          <template v-else-if="currLang == 'sv'" >{{s.vaihtoehtoRuotsiksi}}</template>
                                          <template v-else-if="currLang == 'en'" >{{s.vaihtoehtoEnglanniksi}}</template>
                                          </span>
                                       </td>
                                       <td class="tdRadioBT" v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" >
                                          <template v-if="!!q.kaanteinen">
                                             <label :for="q.id+'scorable'+s.id+'score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" class="fillRadioLabelBT" >
                                             <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score'+(parseInt(q.pisteetMax) - parseInt(n) + 1)" :value="parseInt(q.pisteetMax) - parseInt(n) + 1" >
                                             </label>
                                          </template>
                                          <template v-else>                                          
                                             <label :for="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" class="fillRadioLabelBT" >
                                             <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" :value="parseInt(n) + (parseInt(q.pisteetMin) - 1)" >
                                             </label>                                        
                                          </template>
                                       </td>                                          
                                       <td class="tdRadioBT" >
                                          <label :for="q.id+'scorable'+s.id+'score_nothing'" class="fillRadioLabelBT" >
                                             <input class="fillRadioButtonBT" :ref="'qId'+q.id+'_sId'+s.id+'_scoreEOS'" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score_nothing'" value="eos" >
                                          </label>
                                       </td>
                                    </tr>
                                 </template>							
                              </template>	
                           </tbody>
                        </table>
                     </div>
                     <!-- DIV VERSIO -->
                     <!--
                     <div class="divScorablesTable">
                        <div class="divScorablesTableBody">
                           <div class="divScorablesTableRow">
                              <div class="divScorablesTableCell">&nbsp;</div>
                              <div v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" class="divScorablesTableCell">{{parseInt(n) + (parseInt(q.pisteetMin) - 1)}}</div>
                              <div class="divScorablesTableCell">&nbsp;-&nbsp;</div>
                           </div>
                        
                           <template v-for="s in q.kysymyksenVastausVaihtoehdot" >										
                              <template v-if="s.kysymysId == q.id && s.voimassa == true" >
                                 <div :key="s.id" class="divScorablesTableRow">	
                                    <div class="divScorablesTableCell">
                                       <template v-if="currLang == 'fi'" >{{s.vaihtoehto}}</template>
                                       <template v-if="currLang == 'sv'" >{{s.vaihtoehtoRuotsiksi}}</template>
                                       <template v-if="currLang == 'en'" >{{s.vaihtoehtoEnglanniksi}}</template>
                                    </div>
                                    <div v-for="n in (parseInt(q.pisteetMax) - (parseInt(q.pisteetMin) - 1))" :key="n" class="divScorablesTableCell">
                                       <label :for="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" class="fillRadioLabel" >
                                       <input :ref="'qId'+q.id+'_sId'+s.id+'_score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score'+(parseInt(n) + (parseInt(q.pisteetMin) - 1))" :value="parseInt(n) + (parseInt(q.pisteetMin) - 1)" >
                                       </label>
                                    </div>
                                    <div class="divScorablesTableCell">
                                       <label :for="q.id+'scorable'+s.id+'score_nothing'" class="fillRadioLabel" >
                                          <input :ref="'qId'+q.id+'_sId'+s.id+'_score'" v-model="answers['qId'+q.id+'_sId'+s.id+'_score']" type="radio" :name="q.id+'scorable'+s.id" :id="q.id+'scorable'+s.id+'score_nothing'" value="" >
                                       </label>
                                    </div>
                                 </div>
                              </template>							
                           </template>	
                        
                        </div>
                     </div>
                     -->
                  </div>
                  <!-- SINGLELINE TEXTFIELD -->	
                  <div v-if="q.kysymysTyyppi == 7" class="q-textfield" >
                     <input type="text" v-model="answers['qId'+q.id]" class="form-control" >
                  </div>
                  <!-- MULTILINE TEXTFIELD -->	
                  <div v-if="q.kysymysTyyppi == 3" class="q-textarea" >
                     <textarea v-model="answers['qId'+q.id]" class="form-control" ></textarea>                     
                  </div>
                  <!-- SMILEYS -->	
                  <div v-if="q.kysymysTyyppi == 8" class="q-smileys" >							
                     <input type="hidden" v-model="answers['qId'+q.id+'_smiley']" ref="'qref'+q.id" value="" >
                     <template v-if="q.naamaLkm == 2" >
                        <div class="twoFace" >
                           <b-row >
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 5)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 1)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                              </b-col>
                           </b-row>
                        </div>
                     </template>
                     <template v-if="q.naamaLkm == 3" >
                        <div class="threeFace" >
                           <b-row>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 5)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 3)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 3) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/3b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 1)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                              </b-col>
                           </b-row>
                        </div>
                     </template>
                     <template v-if="q.naamaLkm == 4" >
                        <div class="fourFace" >
                           <b-row>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 5)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 4)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 4) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/4b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 2)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 2) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/2b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 1)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                              </b-col>
                           </b-row>
                        </div>
                     </template>
                     <template v-if="q.naamaLkm == 5" >
                        <div class="fiveFace" >
                           <b-row>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 5)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 5) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/5b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 4)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 4) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/4b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 3)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 3) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/3b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 2)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 2) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/2b.png" ></button>
                              </b-col>
                              <b-col class="faceCol" >
                                 <button @click="smileyButtonClick(q.id, 1)" v-bind:class="(answers['qId'+q.id+'_smiley'] == 1) ? 'smileyButtonActive' : 'smileyButtonPassive'" ><img class="smileyImg" src="../assets/images/1b.png" ></button>
                              </b-col>
                           </b-row>
                        </div>
                     </template>
                  </div>
                  <!-- NPS -->
                  <div v-if="q.kysymysTyyppi == 9" class="q-nps" >		
                     <ul class="NPS">
                        <li v-for="n in 11" :key="n" >
                           <input type="radio" :id="'qId'+q.id+'_nps'+(parseInt(n) - 1)" :name="'qId'+q.kysymysId+'_nps'" :value="(parseInt(n) - 1)" v-model="answers['qId'+q.id+'_nps']" @click="npsSelect(q.id, n-1)" />
                           <label :for="'qId'+q.id+'_nps'+(parseInt(n) - 1)">{{(parseInt(n) - 1)}}</label>
                        </li>
                     </ul>
                     <div><br><br><br></div>
                  </div>               
                  <!-- COMMENTARY TEXTFIELD -->	
                  <template v-if="q.kommentti == true" >
                     <div><br></div>	
                     <div class="questionText" >
                        <span class="question" >{{getTranslation('CommentsField',currLang)}}</span>                      
                     </div>									
                     <div class="q-textarea" >
                        <textarea v-model="answers['qId'+q.id+'_comment']" class="form-control" ></textarea>
                     </div>
                  </template>
               </div>
            </div>
            <div class="previousAndNext" >
               <div class="previous" >
                  <a v-if="currentPage !== firstPageId" href="#" @click="changePage('previous')" class="pageNavigate btn-previous" >&laquo; {{PreviousText}}</a>                  
               </div>
               <div class="next" >
                  <span class="required" v-show="showRequiredInfoInQuestions.length > 0" >{{getTranslation('AnswerRequiredQuestions',currLang)}}</span>
                  <template v-if="currentPage == lastPageId" >
                     <a href="#" 
                     v-bind:class="((showRequiredInfoInQuestions).length < 1) ? 'pageNavigate btn-next' : 'pageNavigate btn-next-disabled'"
                     class="pageNavigate btn-next"
                     @click.prevent="changePage('finish')" >{{ReadyText}} &raquo;</a>
                  </template>
                  <!-- v-bind:class="((showRequiredInfoInQuestions).length < 1) ? 'pageNavigate btn-next' : 'pageNavigate btn-next-disabled' " -->
                  <template v-else >
                     <a href="#" 
                     class="pageNavigate btn-next"
                     @click.prevent="changePage('next')" >{{NextText}} &raquo;</a>
                  </template>
                  <!-- v-bind:class="((showRequiredInfoInQuestions).length < 1) ? 'pageNavigate btn-next' : 'pageNavigate btn-next-disabled'" -->
               </div>
            </div>        
         </template>            
		</div>
	   <pre v-if="1==0" >{{$data}}</pre>	
	</div>
</template>



<script>
import axios from "axios";
import server from "../server";

export default {
	data() { return {
		isLoading: true,
		errorLoadingData: false,
		temp: '',
		languages: [],
		currLang: '',
		logo: '',
      logosUrl: '',
      pages: [],
      currentPage: '',
      currentPageIndex: 0,
      currentPageQuestions: [],
      PreviousText: '',
      nextText: '',
      ReadyText: '',
      firstPageId: '',
      lastPageId: '',
      answers: {},
      fieldsUpdated: '',
      conditionalPages: [],
      conditionalQuestions: [],
      questionsThatActivates: [],
      choicesThatActivates: [], 
      showConditionalPages: [],
      showConditionalQuestions: [],
      smileyNPSActivations: [],
      pageUrl: '',
      surveyTunnus: '',
      answerRows: [],
      questions: [],
      errorInfo: null,
      showRequiredInfoInQuestions: [],
      postInfo: [],
      finalPageNameFI: '',
      finalPageNameSWE: '',
      finalPageNameENG: '',
      finalPageIngressiFI: '',
      finalPageIngressiSWE: '',
      finalPageIngressiENG: '',
      finalPageSummary: false,
      testingMode: false,
      pageIndicatorColor: '',
      translateArray: [
         {
            key: "UnansweredRequiredField",
            fi: "Tämä on pakollinen kysymys. Ole hyvä ja vastaa jatkaaksesi.",
            sv: "Detta är en obligatorisk fråga. Vänligen svara för att fortsätta.",
            en: "Required field. Please answer to continue."
         },
         {
            key: "NextButton",
            fi: "Seuraava",
            sv: "Nästa",
            en: "Next"
         },
         {
            key: "PreviousButton",
            fi: "Edellinen",
            sv: "Förra",
            en: "Previous"
         },
         {
            key: "ReadyButton",
            fi: "Valmis",
            sv: "Färdig",
            en: "Ready"
         },
         {
            key: "CommentsField",
            fi: "Kommentit:",
            sv: "Kommentarer:",
            en: "Comments:"
         },
         {
            key: "AnswerRequiredQuestions",
            fi: "Vastaa kaikkiin pakollisiin kysymyksiin.",
            sv: "Svara på alla frågor som krävs.",
            en: "Answer all required questions."
         }    
      ]
	}},

   watch: {
      currentPageIndex() {
         window.scrollTo(0, 0);
      }
   },

   updated: function () {
      this.$nextTick(function () {
         this.setValues(this.currentPage);
      })
   },

	mounted() {
      
      var org = this.$route.params.org;
		this.$store.commit('setOrg', org);
      this.surveyTunnus = org;

		var keyType = this.$route.params.keytype;
		var keyCode = this.$route.params.keycode;

      var defaultLanguage = this.$route.query.lang;

		var url = '';
		if (keyType.toLowerCase() == 'k'){
			//answer not exists yet (public link)
			var survey = this.$route.params.keycode;
			if (!survey) {
				survey = "";				
			}	
         this.pageUrl = server.makeUrl(`/${org}/k/${keyCode}`);
         var url = server.makeUrl(`/${org}/k/${keyCode}/surveydata`);         
		} else if(keyType.toLowerCase() == 'v'){
         //answer exists (private link or already started filling the survey)
         var answer = this.$route.params.keycode;
			if (!answer) {
				answer = "";				
         }
         this.pageUrl = server.makeUrl(`/${org}/v/${keyCode}`);
			var url = server.makeUrl(`/${org}/v/${keyCode}/surveydata`);
      } else if(keyType.toLowerCase() == 't'){
         //testing link (never save anything to database)
         var testCode = this.$route.params.keycode;
			if (!testCode) {
				testCode = "";				
         }
         this.testingMode = true;
         this.pageUrl = server.makeUrl(`/${org}/t/${keyCode}`);
			var url = server.makeUrl(`/${org}/t/${keyCode}/surveydata`);			
		}

		this.isLoading = true;
		axios.get(url)
			.then(response => {
            if(response.data.hasOwnProperty('errorText')){
               if(response.data.errorText == 'survey not exists'){
                  this.errorInfo = "Kyselyä ei löydy!"
               } else if (response.data.errorText == 'answer not exists'){
                  this.errorInfo = "Kyselyä ei löydy!"
               } else if (response.data.errorText == 'already answered'){
                  this.errorInfo = "Linkillä on jo vastattu kyselyyn "+response.data.additionalInfo+"."
               } else {
                  this.errorInfo = "Kyselyä ei löydy!"
               }
            } else {
               var surveyData = response.data;
               this.$store.commit("setSurvey", surveyData);   
               this.surveyLanguages(defaultLanguage);
               this.logosUrl = this.$store.state.survey.logot.path;            
               this.pages = this.$store.state.survey.sivut.sort((j1,j2) => j1.jarjestys < j2.jarjestys ? -1 : 1);
               this.answerRows = this.$store.state.survey.readVastausRivit;
               this.postInfo = this.$store.state.survey.kyselyLahetys;
               this.currentPage = this.pages[this.currentPageIndex].id;
               this.firstPageId = this.pages[0].id;
               this.lastPageId = this.pages[this.pages.length - 1].id;
               this.finalPageNameFI = this.$store.state.survey.viimeisenSivunNimi;
               this.finalPageNameSWE = this.$store.state.survey.viimeisenSivunNimiRuotsi;
               this.finalPageNameENG = this.$store.state.survey.viimeisenSivunNimiEnglanti;
               this.finalPageIngressiFI = this.removeTagsExceptA(this.$store.state.survey.viimeisenSivunIngressi);
               this.finalPageIngressiSWE = this.removeTagsExceptA(this.$store.state.survey.viimeisenSivunIngressiRuotsi);
               this.finalPageIngressiENG = this.removeTagsExceptA(this.$store.state.survey.viimeisenSivunIngressiEnglanti);
               this.finalPageSummary = this.$store.state.survey.viimeisenSivunYhteenveto;
               this.pageIndicatorColor = this.$store.state.survey.sivuIndikaattorinVari;
               this.initializeThings();

               //window.document.getElementsByTagName("BODY")[0].style.backgroundColor='#F0F0F0';


            }
			})
			.finally(
            () => this.isLoading = false
			)
			.catch(err => {
				console.log(err);
				this.errorLoadingData = true;
			})


	},

	computed: {
    
	},

	methods: {
      
      formatChoice(numericValue, currentLanguage, textValueFI, textValueSWE, textValueENG){
         var temp = '';
         var textValue = '';

         if(currentLanguage.toLowerCase() == 'fi' && textValueFI !== null){
            textValue = textValueFI;
         }
         if(currentLanguage.toLowerCase() == 'sv' && textValueSWE !== null){
            textValue = textValueSWE;
         }
         if(currentLanguage.toLowerCase() == 'en' && textValueENG !== null){
            textValue = textValueENG;
         }

         if(numericValue !== '' && numericValue !== null && numericValue !== undefined){				
            temp = numericValue;
            if(textValue !== ''){
               temp = temp + ' - ';
            }
         }

         temp = temp + textValue;
         
         return temp;
      },

      smileyButtonClick(qId, val){
         //alert(qId + ' ' + val);
         
         if (this.answers['qId'+qId+'_smiley'] == val){
            this.answers['qId'+qId+'_smiley'] = "";
         } else {
            this.answers['qId'+qId+'_smiley'] = val;
         }
         
         this.fieldsUpdated = Date.now();

         this.smileyNPSActivations.forEach(activation => {
            if (activation.questionId == qId)
               this.smileyNPSActivatesPagesOrQuestions(qId, val);
         })
         
      },

      npsSelect(questionId, value){
         this.smileyNPSActivations.forEach(activation => {
            if (activation.questionId == questionId)
               this.smileyNPSActivatesPagesOrQuestions(questionId, value);
         })
      },

      smileyNPSActivatesPagesOrQuestions(questionId, smileyValue){
         // Poistetaan mahdolliset aiemmat tämän kysymyksen aiheuttaman ehdollisen aktivoinnit
         this.showConditionalQuestions = this.showConditionalQuestions.filter(scq => scq.qId !== questionId);
         this.showConditionalPages = this.showConditionalPages.filter(scq => scq.qId !== questionId);

         this.smileyNPSActivations.forEach(activation => {
            if (activation.questionId == questionId && activation.numericValue == smileyValue){
               activation.activates == "page" ? this.showConditionalPages.push({qId: questionId, activates: activation.activatesId})
                                              : this.showConditionalQuestions.push({qId: questionId, activates: activation.activatesId});
            }
         })
      },


      initializeThings()
      {
         // Inserts helpfull stuff into variables, like:
         //- conditional pages and questions
         //- question information 
         //- etc.

         //Loop pages
         for (var p = 0, len = this.pages.length; p < len; p += 1) {
            
            if (this.pages[p].sivunKysymykset !== null){
               //Loop questions (under pages)
               for (var k = 0, klen = this.pages[p].sivunKysymykset.length; k < klen; k += 1) {
                  // hymiöiden ja NPS:n ehdollisuus lisätty jälkikäteen, eikä sitä saanut fiksusti sovitettua valmiina olleeseen valintojen ehdollisuuteen
                  if (this.pages[p].sivunKysymykset[k].kysymysTyyppi == 8 || this.pages[p].sivunKysymykset[k].kysymysTyyppi == 9) { 
                     this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot.forEach(choice => {
                        this.smileyNPSActivations.push({"questionId": choice.kysymysId,
                                                "numericValue": choice.numeerinenArvo,
                                                "activates": !!choice.ehdollisuus[0].aktivoiSivun && choice.ehdollisuus[0].aktivoiSivun > 0 ? "page" : "question",
                                                "activatesId": !!choice.ehdollisuus[0].aktivoiSivun && choice.ehdollisuus[0].aktivoiSivun > 0 ? choice.ehdollisuus[0].aktivoiSivun : choice.ehdollisuus[0].aktivoiKysymyksen 
                                             })
                        !!choice.ehdollisuus[0].aktivoiSivun && choice.ehdollisuus[0].aktivoiSivun > 0 ? this.conditionalPages.push(choice.ehdollisuus[0].aktivoiSivun)
                                                                                                       : this.conditionalQuestions.push(choice.ehdollisuus[0].aktivoiKysymyksen);                                            
                     })
                     // Tarkistetaan vanhoista vastauksista sivua ladatessa ehdollisuudet
                     if (!!this.answerRows){
                        this.answerRows.forEach(answer => {
                           this.smileyNPSActivations.forEach(activation => {
                              if (activation.questionId == answer.kysymysId && (activation.numericValue == answer.hymioNumero || activation.numericValue == answer.pisteet)) {
                                 activation.activates == "page" ? this.showConditionalPages.push({qId: answer.kysymysId, activates: activation.activatesId})
                                                               : this.showConditionalQuestions.push({qId: answer.kysymysId, activates: activation.activatesId});
                              }
                           })
                        })
                     }
                      
                  } else {
                     var existsInQuestionsThatActivatesList = false;
                     if (this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot !== null){
                        //Loop choices (under questions)
                        var choiceIdList = [];
                        for (var vve = 0, vlen = this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot.length; vve < vlen; vve += 1){
                           if(this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].voimassa == true){
                              choiceIdList.push(this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].id);
                           }
                           var existsInChoicesThatActivatesList = false;
                           if (this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].ehdollisuus !== null){
                              //Loop conditionality rules (under choices)                           
                              for (var c = 0, clen = this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].ehdollisuus.length; c < clen; c += 1){                              
                                 var pId
                                 var qId                     
                                 pId = this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].ehdollisuus[c].aktivoiSivun;
                                 qId = this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].ehdollisuus[c].aktivoiKysymyksen;                              
                                 if(pId !== '' && pId !== null && pId !== undefined){
                                    this.conditionalPages.push(pId);
                                 }
                                 if(qId !== '' && qId !== null && qId !== undefined){
                                    this.conditionalQuestions.push(qId);
                                 }

                                 if (existsInQuestionsThatActivatesList == false){
                                    this.questionsThatActivates.push(this.pages[p].sivunKysymykset[k].id);
                                    existsInQuestionsThatActivatesList = true;
                                 }
                                 if (existsInChoicesThatActivatesList == false){
                                    this.choicesThatActivates.push(this.pages[p].sivunKysymykset[k].kysymyksenVastausVaihtoehdot[vve].id);
                                    existsInChoicesThatActivatesList = true;

                                 }

                              }
                           }
                        }
                     }						
                  }
                  var qInfo = {
                     id: this.pages[p].sivunKysymykset[k].id,
                     typeId: this.pages[p].sivunKysymykset[k].kysymysTyyppi,
                     answerRequired: this.pages[p].sivunKysymykset[k].pakollinen,
                     pageId: this.pages[p].id,
                     choices: choiceIdList
                  }
                  
                  this.questions.push(qInfo);

               }
            }
         }
      },

      setValues(pageId){

         if(this.answerRows !== null && this.answerRows !== undefined){
            for (var x = 0, len = this.answerRows.length; x < len; x+=1){
                     
               var questionId = this.answerRows[x].kysymysId;
               
               var questionExistsInPage = false;

               var choiceId = this.answerRows[x].vaihtoehtoId;
               var otherWhat = this.answerRows[x].muuMika;
               var textAnswer = this.answerRows[x].vastaus;
               var points = this.answerRows[x].pisteet;
               
               if(this.answerRows[x].eos == true && this.answerRows[x].pisteet == null){
                  var points = "EOS"
               }

               var smileyNumber = this.answerRows[x].hymioNumero;

               var commentText = this.answerRows[x].kommentti;

               var question = [];
               question = this.questions.filter((qObj)=>{return qObj.id === questionId;}).pop();
               
               var questionType = question.typeId;

               
               
               if(question.pageId == pageId){
               
                  switch(questionType) {
                     case 1:
                        //Radiobutton;                        
                        if(!('qId'+questionId+'_choice' in this.answers)){
                           if(this.$refs['qId'+questionId+'_cId'+choiceId]){
                              var el = this.$refs['qId'+questionId+'_cId'+choiceId][0];                        
                              el.click();
                           }
                        }
                        break;
                     case 2:
                     case 10:
                        //Checkbox
                        if(!('qId'+questionId+'_cId'+choiceId in this.answers)){
                           if(this.$refs['qId'+questionId+'_cId'+choiceId]){
                              var el = this.$refs['qId'+questionId+'_cId'+choiceId][0];                        
                              el.click();
                           }
                        }
                        break;
                     case 3:
                        //multiline text-field
                        if(!('qId'+questionId in this.answers)){
                           this.answers['qId'+questionId] = textAnswer;
                        }
                        break;
                     case 4:
                        //scorables
                        if(!('qId'+questionId+'_sId'+choiceId+'_score' in this.answers)){
                           if(this.$refs['qId'+questionId+'_sId'+choiceId+'_score'+points]){
                              var el = this.$refs['qId'+questionId+'_sId'+choiceId+'_score'+points][0];                        
                              el.click();                                          
                           }
                        }
                        break;      
                     case 5:
                        //dropdown 
                        if(!('qId'+questionId+'_choice' in this.answers)){
                           if (this.$refs['qId'+questionId]){
                              var el = this.$refs['qId'+questionId][0];
                              el.value = choiceId; 
                              el.dispatchEvent(new Event("change"));
                           }
                        }
                        break;
                     case 6:
                        
                        break;
                     case 7:
                        //singleline text-field
                        if(!('qId'+questionId in this.answers)){
                           this.answers['qId'+questionId] = textAnswer;
                        }
                        break;                            
                     case 8:
                        if(!('qId'+questionId+'_smiley' in this.answers)){
                           this.answers['qId'+questionId+'_smiley'] = smileyNumber;
                        }
                        break;                  
                     case 9:
                        //NPS (0-10)
                        if(!('qId'+questionId+'_nps' in this.answers)){
                           this.answers['qId'+questionId+'_nps'] = points;
                        }
                        break;                
                     default:
                        // do nothing
                  }            
                  
                  //"Muu Mikä?"-teksti
                  if(!('qId'+questionId+'_cId'+choiceId+'_otherChoiceText' in this.answers)){
                     if(otherWhat !== '' && otherWhat !== null && otherWhat !== undefined){
                        this.answers['qId'+questionId+'_cId'+choiceId+'_otherChoiceText'] = otherWhat;
                     }
                  }

                  if(!('qId'+questionId+'_comment' in this.answers)){
                     if(commentText !== '' && commentText !== null && commentText !== undefined){
                        this.answers['qId'+questionId+'_comment'] = commentText;
                     }
                  }

               }
            }
         } 
      },

      singleChoiceQuestionConditionals(event, qId, pId, inspect){
         if (inspect == true){
            
            //Poistetaan mahdolliset aiemmat tämän kysymyksen aiheuttaman ehdollisen aktivoinnit
            this.showConditionalQuestions = this.showConditionalQuestions.filter(scq => scq.qId !== qId);
            this.showConditionalPages = this.showConditionalPages.filter(scq => scq.qId !== qId);

            //Jos uusi arvo aiheuttaa ehdollisten aktivointeja, niin lisätään kysymykset tai sivut "näytetään" listaan
            var selectedValue = event.target.value;
            
            var page = [];
            page = this.pages.filter((pObj)=>{return pObj.id === pId;}).pop();

            var question = [];
            question = page.sivunKysymykset.filter((qObj)=>{return qObj.id === qId;}).pop();

            var choice = [];         
            choice = question.kysymyksenVastausVaihtoehdot.filter((cObj)=>{return cObj.id == selectedValue;}).pop();

            var conditionals = [];
            
            if (choice.ehdollisuus !== null && choice.ehdollisuus !== undefined){
               conditionals = choice.ehdollisuus;

               for (var x = 0, len = conditionals.length; x < len; x+=1){
                  // && conditionals[x].vaihtoehtoId == selectedValue
                  if(conditionals[x].aktivoiSivun !== null){
                     this.showConditionalPages.push({qId: qId, activates: conditionals[x].aktivoiSivun});
                  }
                  // && conditionals[x].vaihtoehtoId == selectedValue
                  if(conditionals[x].aktivoiKysymyksen !== null){
                     this.showConditionalQuestions.push({qId: qId, activates: conditionals[x].aktivoiKysymyksen});
                  }
               }
            }

         }
      },

      checkboxConditionals(event, qId, pId, inspect){
         if (inspect == true){
            
            var value = event.target.value;
            var checked = event.target.checked;

            var page = [];
            page = this.pages.filter((pObj)=>{return pObj.id === pId;}).pop();
            
            var question = [];
            question = page.sivunKysymykset.filter((qObj)=>{return qObj.id === qId;}).pop();

            var choice = [];         
            choice = question.kysymyksenVastausVaihtoehdot.filter((cObj)=>{return cObj.id == value;}).pop();

            var conditionals = [];
            
            if (choice.ehdollisuus !== null && choice.ehdollisuus !== undefined){
               conditionals = choice.ehdollisuus;

               for (var x = 0, len = conditionals.length; x < len; x+=1){
                  if(conditionals[x].aktivoiSivun !== null){
                     if (checked == true){
                        this.showConditionalPages.push({cId: value, activates: conditionals[x].aktivoiSivun});
                     } else {
                        this.showConditionalPages = this.showConditionalPages.filter(scq => scq.cId !== value);
                     }
                  }
                  if(conditionals[x].aktivoiKysymyksen !== null){
                     if (checked == true){
                        this.showConditionalQuestions.push({cId: value, activates: conditionals[x].aktivoiKysymyksen});
                     } else {
                        this.showConditionalQuestions = this.showConditionalQuestions.filter(scq => scq.cId !== value);
                     }
                  }
               }
            }

         }

      },

      checkMaxChoices(questionId, checkboxId, answerId, maxChoices, qChoices) {
         var choices = qChoices.map(choice => questionId + 'choice' + choice.id);
         if (choices.filter(choice => document.getElementById(choice).checked).length > maxChoices) {
            this.answers[answerId] = false;
            document.getElementById(checkboxId).checked = false;
            return false;
         }
         return true;
              
      },

		surveyLanguages(defaultLanguage){
			this.languages = [];
         var first = true;
         
         var defaultLanguageExists = false;

			if (this.$store.state.survey.kielet.fi == true){
				this.languages.push({text: 'suomeksi', value: 'fi', first:first});            
            if(defaultLanguage !== undefined){
               if(defaultLanguage.toLowerCase() == 'fi'){
                  defaultLanguageExists = true;
               }
            }
            if(first==true){this.setCurrentLanguage("fi");}            
            first = false;
			}
			if (this.$store.state.survey.kielet.sv == true){
				this.languages.push({text: 'på svenska', value: 'sv', first:first});
            if(defaultLanguage !== undefined){
               if(defaultLanguage.toLowerCase() == 'sv'){
                  defaultLanguageExists = true;
               }
            }
            if(first==true){this.setCurrentLanguage("sv");}
				first = false;
			}
			if (this.$store.state.survey.kielet.en == true){
				this.languages.push({text: 'in english', value: 'en', first:first});
            if(defaultLanguage !== undefined){
               if(defaultLanguage.toLowerCase() == 'en'){
                  defaultLanguageExists = true;
               }
            }
            if(first==true){this.setCurrentLanguage("en");}
				first = false;
         }
         
         if(defaultLanguageExists){
            this.setCurrentLanguage(defaultLanguage.toLowerCase());
         }

		},
		setCurrentLanguage(value){
			this.currLang = value;
         this.PreviousText = this.getTranslation('PreviousButton',value);
         this.NextText = this.getTranslation('NextButton',value);
         this.ReadyText = this.getTranslation('ReadyButton',value);         
			this.logo = this.$store.state.survey.logo[value];	
      },
      getTranslation(key, langCode){
         return this.translateArray.filter((obj)=>{return obj.key === key;}).pop()[langCode];
      },
      changePage(direction){
         if(direction == 'next'){
            //MUISTA tarkistus onko vastattu pakollisiin!!!
            var showNextPage = false;
            if(this.requiredFieldsAnswered(this.currentPage) == true){
               
            
               do {
                  this.currentPageIndex++;
                  if (!(this.conditionalPages.includes(this.pages[this.currentPageIndex].id)) || this.showConditionalPages.some(sp => sp.activates == this.pages[this.currentPageIndex].id)){
                     showNextPage = true
                  }
                  if (this.conditionalPages.includes(this.pages[this.currentPageIndex].id) && this.pages[this.currentPageIndex].id == this.lastPageId && showNextPage == false){
                     this.changePage('finish');
                  }
               }
               while (showNextPage == false);

               this.currentPage = this.pages[this.currentPageIndex].id;

               this.saveAnswers(false);
               this.setValues(this.currentPage);            

            }

         } else if (direction == 'previous') {
            
            this.showRequiredInfoInQuestions = [];
            var showPreviousPage = false;
           
            do {
               this.currentPageIndex--;
               if (!(this.conditionalPages.includes(this.pages[this.currentPageIndex].id)) || this.showConditionalPages.some(sp => sp.activates == this.pages[this.currentPageIndex].id)){
                  showPreviousPage = true
               }
            }
            while (showPreviousPage == false);
            
            this.currentPage = this.pages[this.currentPageIndex].id;

            this.saveAnswers(false);
            this.setValues(this.currentPage);

         } else if (direction == 'finish') {
            
            if(this.requiredFieldsAnswered(this.currentPage) == true){
               this.saveAnswers(true);            
               this.currentPage = 0 // final page               
            }
         }
      },

      requiredFieldsAnswered(currentPageId){
         var allAnswered = true;
         this.showRequiredInfoInQuestions = [];
         
         var requiredQuestions = this.questions.filter((qObj)=>{return (qObj.pageId == currentPageId && qObj.answerRequired == true);});

         for (var x = 0, len = requiredQuestions.length; x < len; x+=1){
            var questionType = requiredQuestions[x].typeId;
            var qId = requiredQuestions[x].id;
            if (!(this.conditionalQuestions.includes(qId)) || this.showConditionalQuestions.some(sq => sq.activates == qId)){
               switch(questionType) {
                  case 1:
                     //Radiobutton;                        
                     if(!('qId'+qId+'_choice' in this.answers)){
                        //ei ole vastausriveissä
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId+'_choice'] == null || this.answers['qId'+qId+'_choice'] == '') {
                           //Vastaus on tyhjä
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false;
                        }
                     }                     
                     break;
                  case 2:
                     //Checkbox choices                     
                     var questionChoices = requiredQuestions[x].choices;
                     var answerCounter = 0;
                     for (var i = 0, clen = questionChoices.length; i < clen; i+=1){
                        if('qId'+qId+'_cId'+questionChoices[i] in this.answers){
                           if(this.answers['qId'+qId+'_cId'+questionChoices[i]] == true) {
                              answerCounter = answerCounter + 1;
                           }
                        }
                     }
                     if(answerCounter == 0){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     }
                     break;
                  case 3:
                     //multiline text-field
                     if(!('qId'+qId in this.answers)){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId] == null || this.answers['qId'+qId] == ''){
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false;
                        }
                     }
                     break;
                  case 4:
                     //scorables
                     var questionScorables = requiredQuestions[x].choices;
                     var scorableMissing = false;
                     for (var i = 0, slen = questionScorables.length; i < slen; i+=1){
                        
                        if(('qId'+qId+'_sId'+questionScorables[i]+'_score') in this.answers){
                           var nro = this.answers[('qId'+qId+'_sId'+questionScorables[i]+'_score')];                           
                           if((nro+'').toLowerCase() !== 'eos'){
                              nro = parseInt(nro);
                              if(Number.isInteger(nro) == false) {                              
                                 scorableMissing = true;
                              }
                           }                           
                        } else {
                           scorableMissing = true;
                        }
                     }
                     if(scorableMissing == true){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     }                     
                     break;      
                  case 5:
                     //dropdown 
                     
                     if(!('qId'+qId+'_choice' in this.answers)){
                        //ei ole vastausriveissä
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId+'_choice'] == null || this.answers['qId'+qId+'_choice'] == '') {
                           //Vastaus on tyhjä
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false;
                        }
                     } 
                     break;
                  case 7:
                     //singleline text-field
                     if(!('qId'+qId in this.answers)){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId] == null || this.answers['qId'+qId] == ''){
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false;
                        }
                     }
                     break;                     
                  case 8:
                     //smileys
                     if(!('qId'+qId+'_smiley' in this.answers)){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId+'_smiley'] == null || this.answers['qId'+qId+'_smiley'] == ''){
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false; 
                        }
                     }
                     break; 
                  case 9:
                     //NPS (0 - 10)
                     if(!('qId'+qId+'_nps' in this.answers)){
                        this.showRequiredInfoInQuestions.push(qId);
                        allAnswered = false;
                     } else {
                        if(this.answers['qId'+qId+'_nps'] == null || this.answers['qId'+qId+'_nps'] == ''){
                           this.showRequiredInfoInQuestions.push(qId);
                           allAnswered = false; 
                        }
                     }
                     break;                  
                  default:
                     
               }                      

            }
         }
         if(allAnswered == true){
            this.showRequiredInfoInQuestions = [];
         }
         return allAnswered;     
      },

      saveAnswers(isFinalPage){
         
         var url = this.pageUrl + '/save'
  
         let formData = new FormData();

         for (var key of Object.keys(this.answers)) {
            //console.log(key + ": " + this.answers[key])
            formData.append(key, this.answers[key]);
         }
         
         var returnedAnswerCode;
  
         axios.post(url,
               formData,
               {						
               	headers: {
                    'Content-Type': 'multipart/form-data'
                  },
               }
				).then(response => {
               returnedAnswerCode = response.data;

               if (returnedAnswerCode == undefined){
                  alert('Something went wrong...');
               } else if (returnedAnswerCode.toLowerCase() == "testing_mode"){
                  //do not change url
               } else {               
                  var newPath = '/'+this.surveyTunnus+'/v/'+returnedAnswerCode;
                  this.pageUrl = server.makeUrl(newPath);
                  window.history.replaceState(null, null, newPath);
                  if(isFinalPage == true){
                     this.surveyReady(returnedAnswerCode);
                  }
               }
				})				
				.catch(function(){
					console.log('Saving error!');
				});   


      },
      surveyReady(answerCode){
         
         if(this.testingMode == false){

            var path = '/'+this.surveyTunnus+'/v/'+answerCode+'/finalpage';

            var url = server.makeUrl(path);
            var returnData;

            axios.post(url)
               .then(response => {
                  returnData = response.data;
                  if (returnData.toLowerCase() == 'ok'){
                     console.log('Survey finished.');
                  }
               })				
               .catch(function(){
                  console.log('Finishing error!');
               });   
         }
      },
      removeTagsExceptA(text){
         if(text !== null){
            return text.replace(/<\/?(?!a)\w*\b[^>]*>/ig, '');
         } else {
            return '';
         }
      }

   }


}
</script>

<style lang="less">
   html, body{      
      background-color: #F0F0F0;
   }   
   .pageContent{
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-size: 1.0em;
      padding-top:20px;
      padding-bottom:20px;
      @media only screen and (hover: none) and (pointer: coarse){
         padding:0px;
         overflow-wrap: break-word;
      }      
      background-color: #F0F0F0;
      width:100%;
   }
   .surveyContent {
      font-size: 16px;
      position: relative;
      margin: 0;
      padding: 0;
      background-color: #F0F0F0;     
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;      
	}
   div.single-question {
      background-color: #fff;
      position: relative;
      border: 1px solid rgba(0,0,0, 0.2);
      box-shadow: 0px 0px 3px 1px rgba(0,0,0, 0.1);	
      padding-left: 20px;
      padding-right: 20px;	
      padding-bottom: 20px;
      padding-top: 20px;
      margin-top:45px;
   }

   div.introductory-paragraph {
      background-color: #fff;
      position: relative;      
      border: 1px solid rgba(0,0,0, 0.2);
      box-shadow: 0px 0px 3px 1px rgba(0,0,0, 0.1);
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 20px;
      padding-top: 20px;	
   }

	div.logoAndProgression{ 
		display:flex;width:100%;
	}
	div.logo{
		float:left;		
		width:50%;
   }
   
   img.logo{
      max-width: 100%;
      max-height: 200px;
      margin-bottom: 20px;
   }

	div.progression{
      text-align:right;
      display:inline-block;
      width:50%;
   }
   
	div.progressionBalls{
      padding-top:0px;
      margin-top:-25px;
      text-align:right;      
   }

   div.progressionBallsFLR{
      padding-top:0px;
      margin-top:-25px;
      text-align:right;
      float:right;
   }

   div.previousAndNext{
      display:flex;
      width:100%;
      margin-top:45px;
   }
   div.previous{
		float:left;		
      width:50%;      
	}
	div.next{
      text-align:right;
      display:inline-block;
      width:50%;      
   }

   a.pageNavigate {
      text-decoration: none !important;
      display: inline-block;
      padding: 8px 16px;
   }
   a.pageNavigate:hover {
      background-color: #ddd;
      color: black !important;
   }

   a.btn-previous {
      background-color: #bbbbbb;
      color: black !important;
      border: 0px;
      border-radius: 3px;
   }
   a.btn-next-disabled {
      background-color: #ff574a;
      color: white !important;
      border: 0px;
      border-radius: 3px;
   }
   a.btn-next {
      background-color: #696969;
      color: white !important;
      border: 0px;
      border-radius: 3px;
   }
   div.leadParagraph{
      margin-top:10px;
      margin-bottom:10px;
      white-space: pre-wrap;
      /*overflow-wrap: break-word;*/
   }

   div.singleQuestion{
      margin-top:10px;
      margin-bottom:10px;
   }
   div.questionText{
      font-size:1.15em;
      font-weight: bold;
      margin-bottom:10px;
   }
   p.questionAdditionalText{
      margin-bottom: 10px;
      white-space: pre-wrap;
   }
   label.label-radio{
      display: block;
      position: relative;
   }
   label.label-checkbox{
      display: block;
      position: relative;
   }

   .divScorablesTable{
      display: table;
      width: 100%;
   }
   .divScorablesTableRow {
      display: table-row;
   }
   .divScorablesTableHeading {
      background-color: #EEE;
      display: table-header-group;
   }
   .divScorablesTableCell, .divScorablesTableHead {
      border: 1px solid #999999;
      display: table-cell;
      padding-left: 3px;
      padding-right: 3px;
      padding-top: 2px;
      padding-bottom: 2px;
      text-align:center;
   }
   .divScorablesTableCellAlignLeft, .divScorablesTableHeadAlignLeft {
      border: 1px solid #999999;
      display: table-cell;
      padding-left: 3px;
      padding-right: 3px;
      padding-top: 2px;
      padding-bottom: 2px;
      text-align:left;
   }
   .divScorablesTableCellAlignRight, .divScorablesTableHeadAlignRight {
      border: 1px solid #999999;
      display: table-cell;
      padding-left: 3px;
      padding-right: 3px;
      padding-top: 2px;
      padding-bottom: 2px;
      text-align:right;
   }
   .divScorablesTableHeading {
      background-color: #EEE;
      display: table-header-group;
      font-weight: bold;
   }
   .divScorablesTableFoot {
      background-color: #EEE;
      display: table-footer-group;
      font-weight: bold;
   }
   .divScorablesTableBody {
      display: table-row-group;
   }

   .scorableBold{
      font-size: 1.0em;
      font-weight: bold;	
   }

   .fillRadioLabel {
      display:block;
      width:100%;
      min-height: 100%;
      height: auto !important;
      height: 100%;
      background-color:white;
      cursor:pointer;
      text-align:center;      
   }

   .fillRadioLabelBT{
      text-align: center;	
      width:100%;
      height:100%;
      margin:0px !important;
   }
   .fillRadioButtonBT{
      margin:auto !important;
   }

   .tdRadioBT{      
      text-align: center;
      vertical-align: middle;	
   }
   .smileyButtonActive{
      background-color:gray;
      outline: none !important;
      border:none;
      padding: 5px;
      border-radius: 5%;
      /*border-radius: 50%;*/
   }
   .smileyButtonPassive{
      background-color:white;
      border:none;
      outline: none !important;
      padding: 5px;
      border-radius: 5%;
      /*border-radius: 50%;*/
      border-color:white;
   }

   p.required{
      color: red;
   }

   span.required{
      color: red;
      margin-right: 10px;
   }
   
   .NPS {
      list-style-type: none;
      margin: 25px 0 0 0;
      padding: 0;
   }   
   .NPS li {
      float: left;
      margin: 0 -1px 0 0;
      width: 45px;
      height: 45px;
      position: relative;
   }   
   .NPS label,
   .NPS input {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
   }
   .NPS input[type="radio"] {
      opacity: 0.01;
      z-index: 100;
   }
   .NPS input[type="radio"]:checked+label,
   .Checked+label {
      background: rgb(170, 170, 170);	
   }
   .NPS label {
      padding: 5px;
      border: 1px solid #CCC;
      cursor: pointer;
      z-index: 90;
      text-align: center;
   }
   .NPS label:hover {
      background: #DDD;
   }
   div.testingInfo{
      color:red;
      font-size: 125%;
      /*margin-top:15px;*/
      margin-bottom:15px;
      color:red;
      border:1px solid red;
      border-radius: 5px;
      padding:10px;
      line-height:1.3em;
      text-align: center;
   }

   div.pageTitle {
      padding-top:10px;
      padding-bottom:10px;
      font-size: 20px;
      font-weight:450;
   }

   div.surveyTitle {
      font-size: 24px; 
      font-weight:500;
   }


   .faceCol{
      padding:0px !important;
      margin:0px !important;
   }
   .smileyImg{
      width: 100%;
      height: auto;
      max-width: 80px;
      @media only screen and (hover: none) and (pointer: coarse){
         max-width:80px;
      }  
   }

   .twoFace{
      max-width:160px;
      padding: 0px 15px 0px 15px;
      @media only screen and (hover: none) and (pointer: coarse){
         max-width:160px;
      }  
   }

   .threeFace{
      max-width:240px;
      padding: 0px 15px 0px 15px;   
      @media only screen and (hover: none) and (pointer: coarse){
         max-width:240px;
      }           
   }

   .fourFace{
      max-width:320px;
      padding: 0px 15px 0px 15px;
      @media only screen and (hover: none) and (pointer: coarse){
         max-width:320px;
      }  
   }

   .fiveFace{
      max-width:400px;
      padding: 0px 15px 0px 15px;  
      @media only screen and (hover: none) and (pointer: coarse){
         max-width:400px;
      }      
   }

</style>
